import Hero from './components/Hero';
import ModulosPoder from './components/ModulosPoder';
import EstrategiaCampanas from './components/EstrategiaCampanas';
import Comparativa from './components/Comparativa';
import Bonos from './components/Bonos';
import OfertaIrresistible from './components/OfertaIrresistible';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import FloatingButton from './components/FloatingButton';

export default function Home() {
  return (
    <div className="min-h-screen bg-[#FAF9F6]">
      <Hero />
      <ModulosPoder />
      <EstrategiaCampanas />
      <Comparativa />
      <Bonos />
      <OfertaIrresistible />
      <FAQ />
      <Footer />
      <FloatingButton />
    </div>
  );
}